module.exports = __webpack_public_path__ + "media/images/athletes/4155-2e55ea5d86908b88316ba07624cd54d2.png";